/**
 * The placeholder shown wherever an image is missing or fails to load, inline so it can never
 * itself 404. Rendered with `object-fit: cover` at each call site, whatever the aspect ratio.
 * Real images come from the v1 asset templates (`src/api/image.js`).
 */
export const FALLBACK_IMAGE_SRC =
  'data:image/svg+xml,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 225">' +
      '<rect width="400" height="225" fill="#1a1a1a"/>' +
      '<path d="M150 145l35-40 30 28 45-55 40 50v22a4 4 0 01-4 4H154a4 4 0 01-4-4z" fill="#333"/>' +
      '<circle cx="170" cy="90" r="14" fill="#333"/>' +
      '</svg>',
  );
